module.exports = __webpack_public_path__ + "img/common_member_bottom_icon.b94efcfb.png";